import { useMutation } from 'react-query'
import { AIJobStatus } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { Data, Options, useCreateFieldsetCompletion, Variables } from './useCreateFieldsetCompletion'
import { fetchFieldsetCompletion } from './fieldsetCompletions/useFieldsetCompletion'

export const useCreateFieldsetCompletionSync = (options?: Options) => {
  const { mutateAsync: createFieldsetCompletion } = useCreateFieldsetCompletion()
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<Data, Error, Variables>(async (vars) => {
    let result = await createFieldsetCompletion(vars)
    const { signal } = vars

    let interval = 500
    do {
      result = await fetchFieldsetCompletion(result.fieldset_completion.id, workspaceId)

      if (signal?.aborted && result) {
        throw new DOMException('The operation was aborted.', 'AbortError')
      }
      if (result?.fieldset_completion.status === AIJobStatus.Failed) {
        throw new Error('Failed to create fieldset')
      }

      await new Promise((resolve) => {
        setTimeout(resolve, interval)
      })
    } while (
      ![AIJobStatus.Failed, AIJobStatus.Expired, AIJobStatus.Successful].includes(result?.fieldset_completion.status)
    )

    return result
  }, options)
}
